/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type DesignLiveAppointmentUpdatedMutationVariables = Types.Exact<{
    requestId: Types.Scalars['ID'];
    input: Types.DesignLiveAppointmentUpdatedEventInput;
}>;

export type DesignLiveAppointmentUpdatedMutation = {
    __typename: 'Mutation';
    designLiveAppointmentUpdated: { __typename: 'Request'; publicId: string };
};

export const DesignLiveAppointmentUpdatedDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DesignLiveAppointmentUpdated' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'requestId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'DesignLiveAppointmentUpdatedEventInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designLiveAppointmentUpdated' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'requestId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'requestId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type DesignLiveAppointmentUpdatedMutationFn = Apollo.MutationFunction<
    DesignLiveAppointmentUpdatedMutation,
    DesignLiveAppointmentUpdatedMutationVariables
>;

/**
 * __useDesignLiveAppointmentUpdatedMutation__
 *
 * To run a mutation, you first call `useDesignLiveAppointmentUpdatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignLiveAppointmentUpdatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designLiveAppointmentUpdatedMutation, { data, loading, error }] = useDesignLiveAppointmentUpdatedMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignLiveAppointmentUpdatedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DesignLiveAppointmentUpdatedMutation,
        DesignLiveAppointmentUpdatedMutationVariables
    >
) {
    return Apollo.useMutation<
        DesignLiveAppointmentUpdatedMutation,
        DesignLiveAppointmentUpdatedMutationVariables
    >(DesignLiveAppointmentUpdatedDocument, baseOptions);
}
export type DesignLiveAppointmentUpdatedMutationHookResult = ReturnType<
    typeof useDesignLiveAppointmentUpdatedMutation
>;
export type DesignLiveAppointmentUpdatedMutationResult =
    Apollo.MutationResult<DesignLiveAppointmentUpdatedMutation>;
export type DesignLiveAppointmentUpdatedMutationOptions = Apollo.BaseMutationOptions<
    DesignLiveAppointmentUpdatedMutation,
    DesignLiveAppointmentUpdatedMutationVariables
>;
